/* eslint-disable no-unused-vars */
import { Field, reduxForm } from 'redux-form';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RenderField, RenderSubmitButton } from '../../../common/form';
import * as Validations from '../../../common/form/commonValidations';
import { updateTables, load } from '../../../../actions/SeatingChartActions';

import './TableModal.less';
import { showModal } from '../../../../actions/ModalActions';


const EditTableModal = ({ handleSubmit, pristine, submitting, valid, onDelete, table, initialValues }) => {
  const seatValidation = (value) => {
    if (value < table.num_filled_seats) {
      return 'Please enter a number more then the number of guests seated';
    }
    return undefined;
  };
  const numSeatRange = (value) => {
    if (value > 99) {
      return 99;
    } else if (value < 0) {
      return 0;
    }
    return undefined;
  };
  return (
    <div>
      <div className="modal-header">
        <h3 className="modal-title">Edit Table</h3>
      </div>
      <form onSubmit={handleSubmit} id="table-form" className="tableModal__form" noValidate>
        <Field
          component={RenderField}
          name="name"
          label="Table Name"
          type="text"
          id="event-name"
          placeholder="8"
          required
          validate={Validations.REQUIRED}
        />
        <Field
          component={RenderField}
          name="num_seats"
          label="Number of Seats"
          type="number"
          id="event-name"
          placeholder="5"
          validate={[numSeatRange, seatValidation, Validations.REQUIRED]}
          required
        />
        <div className="tableModal__buttonGroup">
          <button className="btn btn-danger tableModal__delete-form" onClick={() => onDelete(table)}> Delete Table
          </button>
          <RenderSubmitButton
            className="tableModal__form--save" pristine={pristine} submitting={submitting}
            valid={valid}
          />
        </div>
      </form>
    </div>
  );
};

EditTableModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  initialValues: PropTypes.shape({}),
  onDelete: PropTypes.func,
  table: PropTypes.shape({})
};

const mapDispatchToProps = (dispatch, ownProps) => (
  {
    onSubmit(createTaskRequest) {
      const tableList = [];
      const newTable = ownProps.table;
      newTable.name = createTaskRequest.name;
      newTable.num_seats = createTaskRequest.num_seats;
      tableList.push(newTable);
      dispatch(updateTables(tableList)).then(() => {
        ownProps.hideModalFn();
      });
    },
    onDelete: table => dispatch(showModal('DELETE_TABLE_MODAL', { table }, { size: 'sm' })),
  }
);

const mapStateToProps = state => ({
  initialValues: state.seatingChart.editTableData
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'EditTableModal'
})(EditTableModal));



/** WEBPACK FOOTER **
 ** ./src/components/manage/seatingchart/seatingChartModals/EditTableModal.jsx
 **/